import DOMPurify from 'dompurify'

/**
 * Sanitize admin-authored HTML from the Announcement table before rendering it
 * with dangerouslySetInnerHTML. Strips scripts, event handlers and
 * javascript: URLs. `target` is kept: instruction links open in a new tab, and
 * browsers already treat target="_blank" as noopener. Every announcement and
 * terms row in prod and testing came through unchanged (2026-10-04).
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })
}
